// import React from 'react';
import React, { useEffect } from 'react';

import '../../css/main.css';

import { TextField } from '@material-ui/core';

import CustomCheckbox from '../../components/atoms/CustomCheckbox';


function CustomInputDateCheck({
    id, name, defaultValue,
    id2, name2, defaultValue2,
    labelName2,labelOptions2,
    onChange }) {


    useEffect(() => {

        if (defaultValue) {
            let temp = document.getElementById(id);
            temp.value = defaultValue;
        }
        if (defaultValue2) {
            let temp2 = document.getElementById(id2);
            temp2.value = defaultValue2;
        }

    }, [id, id2, defaultValue, defaultValue2]);


    const handleChange = (e) => { 
        const { name, value } = e.target;
        let event = {
            target: {}
        };
        event.target["name"] = name;
        event.target["value"] = value;

        if (onChange) {
            onChange(event);
        }
    };


    return (
        <>
            <div className={"h_Label1L"} style={{width:"130px"}}>

                <TextField
                    id={id}
                    name={name}
                    className={"k_input"}
                    type="date"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        max:"9999-12-31"
                      }}
                    variant="outlined"
                    onChange={handleChange}
                    defaultValue={defaultValue}
                    style={{ float: "left", width: "100%" }}
                />
            </div>
                
            <div className={"h_Label1L"} style={{width:"70px",marginTop:"-5px",paddingLeft:"10px",whiteSpace:"pre"}}>

                <CustomCheckbox                
                            id={id2}
                            name={name2}
                            options={labelOptions2}
                            onChange={handleChange}
                            paddingLeft={"2px"}
                        />

            </div>
        </>
    );
}

export default CustomInputDateCheck;